(function () {
  if (window.customElements && customElements.get('bz-buybox')) return;

  function delim(n, dec, thou, sep) {
    var parts = n.toFixed(dec).split('.');
    var whole = parts[0], out = '';
    while (whole.length > 3) { out = thou + whole.slice(-3) + out; whole = whole.slice(0, -3); }
    parts[0] = whole + out;
    return parts.join(sep);
  }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var value = (Number(cents) || 0) / 100;
    var a = fmt.indexOf('{{'), b = fmt.indexOf('}}', a + 2);
    var ok = a > -1 && b > a;
    var key = ok ? fmt.slice(a + 2, b).trim() : 'amount';
    var out;
    if (key === 'amount_no_decimals') out = delim(value, 0, ',', '.');
    else if (key === 'amount_with_comma_separator') out = delim(value, 2, '.', ',');
    else if (key === 'amount_no_decimals_with_comma_separator') out = delim(value, 0, '.', ',');
    else out = delim(value, 2, ',', '.');
    return ok ? fmt.slice(0, a) + out + fmt.slice(b + 2) : out;
  }

  class BzBuybox extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var dataEl = this.querySelector('script[data-bz-data]');
      if (!dataEl) return;
      try { this.data = JSON.parse(dataEl.textContent); } catch (e) { console.error('BADGZ buy box data error', e); return; }

      var self = this;
      var d = this.data;
      this.text = d.text || {};
      this.variants = d.variants || [];
      this.byId = new Map(this.variants.map(function (v) { return [String(v.id), v]; }));
      this.min = Math.max(1, parseInt(d.min, 10) || 1);
      var minQ = this.min;
      this.tiers = (d.tiers || []).filter(function (t) { return t.qty >= minQ && t.discount > 0; })
        .sort(function (a, b) { return a.qty - b.qty; });
      this.perks = this.tiers.map(function (t) { return { qty: t.qty, label: t.discount + '% off', pill: t.discount + '% OFF', emoji: '%' }; })
        .concat((d.rewards || []).filter(function (r) { return r.qty >= minQ && r.label; })
          .map(function (r) { return { qty: r.qty, label: String(r.label), pill: r.pill || '', value: r.value || '', image: r.image || '', emoji: r.emoji || '' }; }))
        .sort(function (a, b) { return a.qty - b.qty; });
      this.q = new Map();
      this.single = !!d.single;
      this.cat = 'all';
      this.tiles = {};
      Array.prototype.forEach.call(this.querySelectorAll('[data-tile]'), function (t) { self.tiles[t.dataset.id] = t; });
      this.rail = this.querySelector('[data-rail]');
      this.ctaBtn = this.querySelector('[data-add]');
      this.msgEl = this.querySelector('[data-msg]');

      this.renderRewards();
      this.addEventListener('click', function (e) { self.onClick(e); });

      var urlV = new URLSearchParams(window.location.search).get('variant');
      if (this.single) {
        var only = this.variants[0];
        if (only && only.available) this.q.set(String(only.id), this.min);
      } else if (urlV && this.byId.has(urlV) && this.byId.get(urlV).available) {
        this.q.set(urlV, 1);
      }
      this.update();
      this._ready = true;
      if (urlV && this.tiles[urlV]) this.showTile(urlV, false);

      this.initGallery();
      this.initModal();
      this.initSticky();
    }

    disconnectedCallback() {
      if (this.stickyBar && this.stickyBar.parentNode) this.stickyBar.parentNode.removeChild(this.stickyBar);
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      if (this._io) this._io.disconnect();
    }

    onClick(e) {
      var t = e.target, el;
      if (!t || !t.closest) return;
      if ((el = t.closest('[data-pick]'))) { this.inc(el.closest('[data-tile]').dataset.id); return; }
      if ((el = t.closest('[data-inc]'))) { this.inc(this.idFrom(el)); return; }
      if ((el = t.closest('[data-dec]'))) { this.dec(this.idFrom(el)); return; }
      if ((el = t.closest('[data-chip]'))) { this.filter(el.dataset.chip); return; }
      if ((el = t.closest('[data-rail-prev]'))) { this.slide(-1); return; }
      if ((el = t.closest('[data-rail-next]'))) { this.slide(1); return; }
      if ((el = t.closest('[data-clear]'))) { this.q.clear(); this.update(); return; }
      if ((el = t.closest('[data-add]'))) { this.addToCart(); return; }
    }

    idFrom(el) {
      var tile = el.closest('[data-tile]');
      if (tile) return tile.dataset.id;
      return this.variants[0] ? String(this.variants[0].id) : '';
    }

    count() { var n = 0; this.q.forEach(function (v) { n += v; }); return n; }

    inc(id) {
      id = String(id);
      var v = this.byId.get(id);
      if (!v || !v.available) return false;
      var n = this.q.get(id) || 0;
      var max = v.max > 0 ? v.max : 99;
      if (n >= max) { this.flash('Only ' + max + ' of ' + v.title + ' left.'); return false; }
      this.q.set(id, n + 1);
      this.update();
      if (n === 0 && v.mediaId) this.goToMedia(v.mediaId);
      return true;
    }

    dec(id) {
      id = String(id);
      var n = this.q.get(id) || 0;
      if (!n) return;
      if (this.single && n <= this.min) return;
      if (n === 1) this.q.delete(id); else this.q.set(id, n - 1);
      this.update();
    }

    filter(cat) {
      var self = this;
      this.cat = cat || 'all';
      Array.prototype.forEach.call(this.querySelectorAll('[data-chip]'), function (c) {
        c.setAttribute('aria-pressed', c.dataset.chip === self.cat ? 'true' : 'false');
      });
      Object.keys(this.tiles).forEach(function (id) {
        var t = self.tiles[id];
        t.classList.toggle('is-hidden', self.cat !== 'all' && t.dataset.cat !== self.cat);
      });
      if (this.rail) this.rail.scrollLeft = 0;
    }

    slide(dir) {
      if (this.rail) this.rail.scrollBy({ left: dir * Math.max(240, this.rail.clientWidth * 0.85), behavior: 'smooth' });
    }

    showTile(id, smooth) {
      var t = this.tiles[String(id)];
      if (!t || !this.rail) return;
      if (t.classList.contains('is-hidden')) this.filter('all');
      this.rail.scrollTo({ left: Math.max(0, t.offsetLeft - 20), behavior: smooth ? 'smooth' : 'auto' });
    }

    reveal(id) {
      var p = this.querySelector('[data-picker]') || this;
      p.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.showTile(id, true);
      var t = this.tiles[String(id)];
      if (t) { t.classList.add('is-flash'); setTimeout(function () { t.classList.remove('is-flash'); }, 900); }
    }

    tierAt(n) { var cur = null; this.tiers.forEach(function (t) { if (n >= t.qty) cur = t; }); return cur; }

    nextTier(n) {
      for (var i = 0; i < this.tiers.length; i++) if (this.tiers[i].qty > n) return this.tiers[i];
      return null;
    }

    totals() {
      var self = this, sum = 0, n = 0;
      this.q.forEach(function (qty, id) {
        var v = self.byId.get(id);
        if (v) { sum += v.price * qty; n += qty; }
      });
      var t = this.tierAt(n), pct = t ? t.discount : 0;
      return { n: n, sum: sum, pct: pct, disc: Math.round(sum * (1 - pct / 100)) };
    }

    nextPerk(n) {
      for (var i = 0; i < this.perks.length; i++) if (this.perks[i].qty > n) return this.perks[i];
      return null;
    }

    fmt(c) { return formatMoney(c, this.data.moneyFormat); }

    renderRewards() {
      var row = this.querySelector('[data-rewards]');
      if (!row) return;
      if (!this.perks.length) { row.hidden = true; return; }
      var lockText = this.text.lock || '[qty] PACK';
      var LOCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5zm-3 8V7a3 3 0 1 1 6 0v3H9z"/></svg>';
      row.innerHTML = '';
      row.style.setProperty('--bz-k', Math.min(this.perks.length, 4));
      this.perks.forEach(function (m) {
        var card = document.createElement('div');
        card.className = 'bz-perk';
        card.setAttribute('data-mark', '');
        card.dataset.qty = m.qty;
        var pill = document.createElement('span');
        pill.className = 'bz-perk__pill';
        pill.textContent = m.pill || 'FREE';
        if (m.value) { var s = document.createElement('s'); s.textContent = m.value; pill.appendChild(document.createTextNode(' ')); pill.appendChild(s); }
        card.appendChild(pill);
        var media = document.createElement('div');
        media.className = 'bz-perk__media';
        var art = document.createElement('span');
        art.className = 'bz-perk__art';
        if (m.image) { var img = document.createElement('img'); img.src = m.image; img.alt = ''; img.loading = 'lazy'; art.appendChild(img); }
        else { art.classList.add('bz-perk__emoji'); art.textContent = m.emoji || '🎁'; }
        media.appendChild(art);
        var lock = document.createElement('span');
        lock.className = 'bz-perk__lock';
        lock.innerHTML = LOCK;
        var lt = document.createElement('span');
        lt.textContent = lockText.split('[qty]').join(String(m.qty));
        lock.appendChild(lt);
        media.appendChild(lock);
        card.appendChild(media);
        var label = document.createElement('span');
        label.className = 'bz-perk__label';
        label.textContent = m.label;
        card.appendChild(label);
        row.appendChild(card);
      });
    }

    update() {
      var self = this, T = this.totals(), n = T.n;

      Object.keys(this.tiles).forEach(function (id) {
        var tile = self.tiles[id], c = self.q.get(id) || 0;
        tile.classList.toggle('is-on', c > 0);
        var nEl = tile.querySelector('[data-n]');
        if (nEl) nEl.textContent = c;
      });
      var sn = this.querySelector('[data-single-n]');
      if (sn) sn.textContent = n;

      Array.prototype.forEach.call(this.querySelectorAll('[data-mark]'), function (m) {
        var hit = n >= Number(m.dataset.qty), was = m.classList.contains('is-hit');
        m.classList.toggle('is-hit', hit);
        if (hit && !was && self._ready) {
          m.classList.add('is-pop');
          setTimeout(function () { m.classList.remove('is-pop'); }, 700);
        }
      });

      var nudge = this.querySelector('[data-nudge]');
      if (nudge) {
        var np = this.nextPerk(n), txt = '';
        if (n === 0) txt = this.startText();
        else if (n < this.min) txt = 'Pick ' + (this.min - n) + ' more to unlock your pack';
        else if (np) txt = 'Add ' + (np.qty - n) + ' more for ' + np.label.toLowerCase();
        else if (this.perks.length) txt = this.text.allDone || 'Everything unlocked';
        else txt = this.min > 1 ? (this.text.ready || 'Pack ready') + ' ✓' : '';
        nudge.textContent = txt;
      }

      var ship = this.querySelector('[data-ship]');
      if (ship) {
        var fs = this.data.freeShip || 0;
        if (!fs) { ship.hidden = true; }
        else {
          ship.hidden = false;
          var left = fs - T.disc;
          ship.textContent = n === 0 ? 'Free shipping on orders over ' + this.fmt(fs)
            : left > 0 ? this.fmt(left) + ' away from free shipping' : 'Free shipping unlocked';
        }
      }

      var unit = n === 1 ? (this.text.unit || 'sticker') : (this.text.units || 'stickers');
      var cl = this.querySelector('[data-count-label]');
      if (cl) cl.textContent = n + ' ' + unit;
      var tot = this.querySelector('[data-total]');
      if (tot) tot.textContent = this.fmt(T.disc);
      var was = this.querySelector('[data-was]');
      if (was) was.textContent = T.pct > 0 ? this.fmt(T.sum) : '';
      var clr = this.querySelector('[data-clear]');
      if (clr) clr.hidden = n === 0 || this.single;
      var short = this.min > 1 && n < this.min;
      var ctaText = !short ? (this.text.cta || 'Add to cart') : n === 0 ? 'Pick ' + this.min + ' designs' : 'Pick ' + (this.min - n) + ' more';
      var cl2 = this.querySelector('[data-cta-label]');
      if (cl2) cl2.textContent = ctaText;
      var cp = this.querySelector('[data-cta-price]');
      if (cp) cp.textContent = n > 0 ? '— ' + this.fmt(T.disc) : '';
      if (this.stickyBtn) this.stickyBtn.textContent = n === 0 ? (this.text.sticky || 'Build your pack') : short ? ctaText : ctaText + ' · ' + this.fmt(T.disc);
      this.classList.toggle('is-locked', short);
      if (this.stickyCount) this.stickyCount.textContent = n > 0 ? n + ' ' + unit : '';
      if (this.msgEl) this.msgEl.textContent = '';
    }

    flash(msg) { if (this.msgEl) this.msgEl.textContent = msg; }

    startText() {
      var t = this.text.start || (this.min > 1 ? 'Pick [min] designs to build your pack' : 'Tap a design to start your pack');
      return t.split('[min]').join(String(this.min));
    }

    addToCart() {
      var self = this, T = this.totals();
      if (T.n < this.min) {
        var left = this.min - T.n;
        this.flash(T.n === 0
          ? (this.min > 1 ? 'Packs start at ' + this.min + '. Tap designs to add them.' : (this.text.empty || 'Tap a design to add it to your pack.'))
          : 'Packs start at ' + this.min + '. Add ' + left + ' more.');
        var p = this.querySelector('[data-picker]');
        if (p) p.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var items = [];
      this.q.forEach(function (qty, id) { items.push({ id: Number(id), quantity: qty }); });
      var btns = [this.ctaBtn, this.stickyBtn].filter(Boolean);
      btns.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); });
      var root = this.data.root || '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (json) {
          if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart.');
          window.location.href = root + (self.data.afterAdd === 'checkout' ? 'checkout' : 'cart');
        });
      }).catch(function (err) {
        self.flash(err.message || 'Something went wrong. Try again.');
        if (self.msgEl && self.msgEl.scrollIntoView) self.msgEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        btns.forEach(function (b) { b.disabled = false; b.classList.remove('is-loading'); });
      });
    }

    initGallery() {
      var self = this;
      this.viewport = this.querySelector('[data-viewport]');
      if (!this.viewport) return;
      this.slides = Array.prototype.slice.call(this.viewport.children);
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
      this.thumbs.forEach(function (t, i) { t.addEventListener('click', function () { self.goTo(i); }); });
      var prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { self.goTo(Math.max(0, self.current() - 1)); });
      if (next) next.addEventListener('click', function () { self.goTo(Math.min(self.slides.length - 1, self.current() + 1)); });
      var raf;
      this.viewport.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { self.markThumb(); });
      }, { passive: true });
      this.markThumb();
    }

    current() {
      var w = this.viewport.clientWidth || 1;
      return Math.round(this.viewport.scrollLeft / w);
    }

    goTo(i) {
      if (!this.viewport) return;
      this.viewport.scrollTo({ left: i * this.viewport.clientWidth, behavior: 'smooth' });
    }

    markThumb() {
      var c = this.current();
      (this.thumbs || []).forEach(function (t, i) { t.setAttribute('aria-current', i === c ? 'true' : 'false'); });
    }

    goToMedia(mediaId) {
      if (!this.slides) return;
      var i = this.slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (i > -1) this.goTo(i);
    }

    initModal() {
      var open = this.querySelector('[data-open-modal]');
      var dlg = this.querySelector('[data-modal]');
      if (!open || !dlg) return;
      function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
      open.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
      dlg.querySelectorAll('[data-close-modal]').forEach(function (b) { b.addEventListener('click', close); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    }

    initSticky() {
      var self = this;
      var bar = this.querySelector('[data-sticky]');
      if (!bar || !this.ctaBtn || !('IntersectionObserver' in window)) return;
      if (window.Shopify && window.Shopify.designMode) return;
      document.body.appendChild(bar);
      this.stickyBar = bar;
      bar.hidden = false;
      this.stickyBtn = bar.querySelector('[data-sticky-btn]');
      this.stickyCount = bar.querySelector('[data-sticky-count]');
      if (this.stickyBtn) this.stickyBtn.addEventListener('click', function () {
        if (self.count() >= self.min) { self.addToCart(); return; }
        var target = self.querySelector('[data-picker]') || self;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      var ctaVisible = true;
      this._onScroll = function () { bar.classList.toggle('is-visible', !ctaVisible && window.scrollY > 600); };
      this._io = new IntersectionObserver(function (entries) { ctaVisible = entries[0].isIntersecting; self._onScroll(); });
      this._io.observe(this.ctaBtn);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      this.update();
    }
  }

  customElements.define('bz-buybox', BzBuybox);

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-bz-pick]') : null;
    if (!a) return;
    var bb = document.querySelector('bz-buybox');
    if (!bb || !bb._init || !bb.byId) return;
    var id = String(a.getAttribute('data-bz-pick'));
    if (!bb.byId.has(id)) return;
    e.preventDefault();
    bb.inc(id);
    bb.reveal(id);
  });
})();
